// Vendors
import React from 'react';

const GasRepFields = ({ projectData, updateSpecificProjectDataProperty }) => {
  const allStates = window.wlUSStates;
  const {
    gas_rep_company_name,
    gas_rep_representative,
    gas_rep_city,
    gas_rep_state
  } = projectData;

  // Update projectData object onChange.
  // When user clicks 'SAVE PROPANE PROVIDER', projectData will get sent to endpoint as well, including these (updated) fields.
  const handleFormFieldChange = (event) =>
    updateSpecificProjectDataProperty(event.target.name, event.target.value);

  return (
    <>
      <div className="grid__col-xs-12">
        <h4
          style={{
            margin: '20px 0',
            paddingBottom: '10px',
            borderBottom: '1px solid gray'
          }}
        >
          Propane Provider:
        </h4>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label u--font-weight-bold">
            Company Name
          </label>
          <input
            type="text"
            name="gas_rep_company_name"
            className="form__input"
            value={gas_rep_company_name}
            onChange={(event) => handleFormFieldChange(event)}
          />
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label u--font-weight-bold">
            Representative
          </label>
          <input
            type="text"
            name="gas_rep_representative"
            className="form__input"
            value={gas_rep_representative}
            onChange={(event) => handleFormFieldChange(event)}
          />
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label u--font-weight-bold">City</label>
          <input
            type="text"
            name="gas_rep_city"
            className="form__input"
            value={gas_rep_city}
            onChange={(event) => handleFormFieldChange(event)}
          />
        </div>
      </div>
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label u--font-weight-bold">State</label>
          <div className="form__select form__select--lg form__input--no-shadow">
            <select
              name="gas_rep_state"
              className="form__input form__input--lg"
              value={gas_rep_state}
              onChange={(event) => handleFormFieldChange(event)}
            >
              <option value="">-- Please select state --</option>
              {allStates &&
                Object.keys(allStates).map((singleState, index) => (
                  <option key={index} value={singleState}>
                    {allStates[singleState]}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default GasRepFields;
